var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook Icon"),React.createElement("path",{"d":"M108 0H20C8.95431 0 0 8.95431 0 20V108C0 119.046 8.95431 128 20 128H108C119.046 128 128 119.046 128 108V20C128 8.95431 119.046 0 108 0Z","fill":"#1877F2","key":1}),React.createElement("path",{"d":"M96 64C96 46.4 81.6 32 64 32C46.4 32 32 46.4 32 64C32 80 43.6 93.2 58.8 95.6V73.2H50.8V64H58.8V56.8C58.8 48.8 63.6 44.4 70.8 44.4C74.4 44.4 78 45.2 78 45.2V53.2H74C70 53.2 68.8 55.6 68.8 58V64H77.6L76 73.2H68.4V96C84.4 93.6 96 80 96 64Z","fill":"white","key":2})]);
}

Facebook.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none","className":"icon_wrap"};

module.exports = Facebook;

Facebook.default = Facebook;
